import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=38c5ee9d&lang=pug&"
import script from "./ProductGallery.vue?vue&type=script&lang=ts&"
export * from "./ProductGallery.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports